<section id="home" class="slider_area">
    <div id="carouselThree" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
            <li data-target="#carouselThree" data-slide-to="0" class="active"></li>


        </ol>
        <div class="carousel-inner">

            <div class="carousel-item active">
                <div class="container">
                    <div class="row flex-container">
                        <div class="col-lg-7">
                            <div class="slider-content">
                                <h1 class="title">{{'DOCUMENTS.TITLE' | translate }}</h1>
                                <p class="text">{{'DOCUMENTS.TITLE_DESCRIPTION_SHORT' | translate }}</p>
                                <div class="slider-buttons">
                                    <div class="button-wrap">
                                        <a href="https://admin.propero.io/" target="_blank" class="btn primary-btn">
                                            Propero Assistant
                                        </a>
                                        <span i18n="@@mainSubtitleAdditionalText" class="btn-subtext">
                                            {{ 'HOME.MAIN_SUBTITLE_ADDITIONAL_TEXT' | translate }}
                                        </span>
                                    </div>

                                    <div class="button-wrap">
                                        <a routerLink="/solution-personalised" class="btn secondary-btn"
                                            i18n="@@mainPersonalizedOffer">
                                            {{ 'HOME.MAIN_PERSONALIZED_OFFER' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="slider-image">
                                <img src="assets/images/slider/2.png" alt="Hero">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <a class="carousel-control-prev" href="#carouselThree" role="button" data-slide="prev">
            <i class="lni lni-arrow-left"></i>
        </a>
        <a class="carousel-control-next" href="#carouselThree" role="button" data-slide="next">
            <i class="lni lni-arrow-right"></i>
        </a>
    </div>
</section>

<section id="features" class="features-area">
    <div class="container">
        <div class="section-title">
            <h3 class="title">{{'DOCUMENTS.TITLE' | translate }}</h3>
            <p class="text">{{'DOCUMENTS.TITLE_DESCRIPTION_LONG' | translate }}</p>
        </div>

        <div class="features-grid">
            <div class="feature-widget">
                <div class="widget-badge paid" (click)="onWidgetClick('full_renting_contract')"
                    *ngIf="getDocumentWidgetPrice('full_renting_contract') as fullRentingContractPrice">
                    {{ fullRentingContractPrice?.price || '0.00' }} {{ fullRentingContractPrice?.currency || 'RON' }}
                </div>

                <div class="widget-header">
                    <div class="widget-icon">
                        <i class="lni lni-apartment"></i>
                    </div>
                    <h4 class="widget-title">
                        <a (click)="onWidgetClick('full_renting_contract')">
                            <span class="tooltip-text-title">{{ 'DOCUMENTS.FEATURE1_TITLE' | translate }}</span>
                        </a>
                    </h4>
                </div>
                <div class="widget-content">
                    <p class="widget-text">
                        <a class="tooltip-text-content" (click)="onWidgetClick('full_renting_contract')">
                            <span>{{ 'DOCUMENTS.FEATURE1_TEXT' | translate }}</span>
                        </a>
                    </p>
                    <div class="features-btn-wrapper">
                        <div class="dropdown">
                            <button class="features-btn" (click)="toggleDropdown($event, 'full_renting_contract')">
                                <i class="lni lni-download"></i>
                                Descarcă document
                            </button>
                            <div class="dropdown-menu" [class.show]="activeDropdownId === 'full_renting_contract'">
                                <a href="javascript:void(0)" class="dropdown-item pdf"
                                    (click)="redirectToPayment('full_renting_contract_pdf')"
                                    *ngIf="getDocumentPriceDetails('full_renting_contract_pdf', 'pdf') as full_renting_contract_pdf">
                                    <i class="lni lni-pdf"></i>
                                    Format PDF ({{ full_renting_contract_pdf?.documentPrice || '0.00' }} {{
                                    full_renting_contract_pdf?.subscriptionCurrency || 'RON' }})
                                </a>

                                <a href="javascript:void(0)" class="dropdown-item docx"
                                    (click)="redirectToPayment('full_renting_contract_docx')"
                                    *ngIf="getDocumentPriceDetails('full_renting_contract_docx', 'docx') as full_renting_contract_docx">
                                    <i class="lni lni-file"></i>
                                    Format DOCX ({{ full_renting_contract_docx?.documentPrice || '0.00' }} {{
                                    full_renting_contract_docx?.documentCurrency || 'RON' }})
                                </a>

                                <a href="javascript:void(0)" class="dropdown-item odt"
                                    (click)="redirectToPayment('full_renting_contract_odt')"
                                    *ngIf="getDocumentPriceDetails('full_renting_contract_odt', 'odt') as full_renting_contract_odt">
                                    <i class="lni lni-text"></i>
                                    Format ODT ({{ full_renting_contract_odt?.documentPrice || '0.00' }} {{
                                    full_renting_contract_odt?.documentCurrency || 'RON' }})
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="feature-widget">
                <div class="widget-badge free" (click)="onWidgetClick('inventory')"
                    *ngIf="getDocumentWidgetPrice('inventory') as inventoryPrice">
                    {{ inventoryPrice?.price || '0.00' }} {{ inventoryPrice?.currency || 'RON' }}
                </div>

                <div class="widget-header">
                    <div class="widget-icon">
                        <i class="lni lni-calculator"></i>
                    </div>
                    <h4 class="widget-title">
                        <a (click)="onWidgetClick('inventory')">
                            <span class="tooltip-text-title">{{ 'DOCUMENTS.FEATURE2_TITLE' | translate }}</span>
                        </a>
                    </h4>
                </div>
                <div class="widget-content">
                    <p class="widget-text">
                        <a class="tooltip-text-content" (click)="onWidgetClick('inventory')">
                            <span>{{ 'DOCUMENTS.FEATURE2_TEXT' | translate }}</span>
                        </a>
                    </p>
                    <div class="features-btn-wrapper">
                        <div class="dropdown">
                            <button class="features-btn" (click)="toggleDropdown($event, 'inventory')">
                                <i class="lni lni-download"></i>
                                Descarcă document
                            </button>
                            <div class="dropdown-menu" [class.show]="activeDropdownId === 'inventory'">
                                <a href="javascript:void(0)" class="dropdown-item pdf"
                                    (click)="redirectToPayment('inventory_pdf')"
                                    *ngIf="getDocumentPriceDetails('inventory_pdf', 'pdf') as inventory_pdf">
                                    <i class="lni lni-pdf"></i>
                                    Format PDF ({{ inventory_pdf?.documentPrice || '0.00' }} {{
                                    inventory_pdf?.documentCurrency || 'RON' }})
                                </a>

                                <a href="javascript:void(0)" class="dropdown-item docx"
                                    (click)="redirectToPayment('inventory_docx')"
                                    *ngIf="getDocumentPriceDetails('inventory_docx', 'docx') as inventory_docx">
                                    <i class="lni lni-file"></i>
                                    Format DOCX ({{ inventory_docx?.documentPrice || '0.00' }} {{
                                    inventory_docx?.documentCurrency || 'RON' }})
                                </a>

                                <a href="javascript:void(0)" class="dropdown-item odt"
                                    (click)="redirectToPayment('inventory_odt')"
                                    *ngIf="getDocumentPriceDetails('inventory_odt', 'odt') as inventory_odt">
                                    <i class="lni lni-text"></i>
                                    Format ODT ({{ inventory_odt?.documentPrice || '0.00' }} {{
                                    inventory_odt?.documentCurrency || 'RON' }})
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="feature-widget">
                <div class="widget-badge free" (click)="onWidgetClick('sub_renting_contract')"
                    *ngIf="getDocumentWidgetPrice('sub_renting_contract') as subRentingContractPrice">
                    {{ subRentingContractPrice?.price || '0.00' }} {{ subRentingContractPrice?.currency || 'RON' }}
                </div>

                <div class="widget-header">
                    <div class="widget-icon">
                        <i class="lni lni-cog"></i>
                    </div>
                    <h4 class="widget-title">
                        <a (click)="onWidgetClick('sub_renting_contract')">
                            <span class="tooltip-text-title">{{ 'DOCUMENTS.FEATURE3_TITLE' | translate }}</span>
                        </a>
                    </h4>
                </div>
                <div class="widget-content">
                    <p class="widget-text">
                        <a class="tooltip-text-content" (click)="onWidgetClick('sub_renting_contract')">
                            <span>{{ 'DOCUMENTS.FEATURE3_TEXT' | translate }}</span>
                        </a>
                    </p>
                    <div class="features-btn-wrapper">
                        <div class="dropdown">
                            <button class="features-btn" (click)="toggleDropdown($event, 'sub_renting_contract')">
                                <i class="lni lni-download"></i>
                                Descarcă document
                            </button>
                            <div class="dropdown-menu" [class.show]="activeDropdownId === 'sub_renting_contract'">
                                <a href="javascript:void(0)" class="dropdown-item pdf"
                                    (click)="redirectToPayment('sub_renting_contract_pdf')"
                                    *ngIf="getDocumentPriceDetails('sub_renting_contract_pdf', 'pdf') as sub_renting_contract_pdf">
                                    <i class="lni lni-pdf"></i>
                                    Format PDF ({{ sub_renting_contract_pdf?.documentPrice || '0.00' }} {{
                                    sub_renting_contract_pdf?.documentCurrency || 'RON' }})
                                </a>

                                <a href="javascript:void(0)" class="dropdown-item docx"
                                    (click)="redirectToPayment('sub_renting_contract_docx')"
                                    *ngIf="getDocumentPriceDetails('sub_renting_contract_docx', 'docx') as sub_renting_contract_docx">
                                    <i class="lni lni-file"></i>
                                    Format DOCX ({{ sub_renting_contract_docx?.documentPrice || '0.00' }} {{
                                    sub_renting_contract_docx?.documentCurrency || 'RON' }})
                                </a>

                                <a href="javascript:void(0)" class="dropdown-item odt"
                                    (click)="redirectToPayment('sub_renting_contract_odt')"
                                    *ngIf="getDocumentPriceDetails('sub_renting_contract_odt', 'odt') as sub_renting_contract_odt">
                                    <i class="lni lni-text"></i>
                                    Format ODT ({{ sub_renting_contract_odt?.documentPrice || '0.00' }} {{
                                    sub_renting_contract_odt?.documentCurrency || 'RON' }})
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="features-grid">
            <div class="feature-widget">
                <div class="widget-badge free" (click)="onWidgetClick('end_contract')"
                    *ngIf="getDocumentWidgetPrice('end_contract') as endContractPrice">
                    {{ endContractPrice?.price || '0.00' }} {{ endContractPrice?.currency || 'RON' }}
                </div>

                <div class="widget-header">
                    <div class="widget-icon">
                        <i class="lni lni-apartment"></i>
                    </div>
                    <h4 class="widget-title">
                        <a (click)="onWidgetClick('end_contract')">
                            <span class="tooltip-text-title">{{ 'DOCUMENTS.FEATURE4_TITLE' | translate }}</span>
                        </a>
                    </h4>
                </div>
                <div class="widget-content">
                    <p class="widget-text">
                        <a class="tooltip-text-content" (click)="onWidgetClick('end_contract')">
                            <span>{{ 'DOCUMENTS.FEATURE4_TEXT' | translate }}</span>
                        </a>
                    </p>
                    <div class="features-btn-wrapper">
                        <div class="dropdown">
                            <button class="features-btn" (click)="toggleDropdown($event, 'end_contract')">
                                <i class="lni lni-download"></i>
                                Descarcă document
                            </button>
                            <div class="dropdown-menu" [class.show]="activeDropdownId === 'end_contract'">
                                <a href="javascript:void(0)" class="dropdown-item pdf"
                                    (click)="redirectToPayment('end_contract_pdf')"
                                    *ngIf="getDocumentPriceDetails('end_contract_pdf', 'pdf') as end_contract_pdf">
                                    <i class="lni lni-pdf"></i>
                                    Format PDF ({{ end_contract_pdf?.documentPrice || '0.00' }} {{
                                    end_contract_pdf?.documentCurrency || 'RON' }})
                                </a>

                                <a href="javascript:void(0)" class="dropdown-item docx"
                                    (click)="redirectToPayment('end_contract_docx')"
                                    *ngIf="getDocumentPriceDetails('end_contract_docx', 'docx') as end_contract_docx">
                                    <i class="lni lni-file"></i>
                                    Format DOCX ({{ end_contract_docx?.documentPrice || '0.00' }} {{
                                    end_contract_docx?.documentCurrency || 'RON' }})
                                </a>

                                <a href="javascript:void(0)" class="dropdown-item odt"
                                    (click)="redirectToPayment('end_contract_odt')"
                                    *ngIf="getDocumentPriceDetails('end_contract_odt', 'odt') as end_contract_odt">
                                    <i class="lni lni-text"></i>
                                    Format ODT ({{ end_contract_odt?.documentPrice || '0.00' }} {{
                                    end_contract_odt?.documentCurrency || 'RON' }})
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="feature-widget">
                <div class="widget-badge free" (click)="onWidgetClick('data_beneficiar_real_contract')"
                    *ngIf="getDocumentWidgetPrice('data_beneficiar_real_contract') as beneficiarPrice">
                    {{ beneficiarPrice?.price || '0.00' }} {{ beneficiarPrice?.currency || 'RON' }}
                </div>

                <div class="widget-header">
                    <div class="widget-icon">
                        <i class="lni lni-cog"></i>
                    </div>
                    <h4 class="widget-title">
                        <a (click)="onWidgetClick('data_beneficiar_real_contract')">
                            <span class="tooltip-text-title">{{ 'DOCUMENTS.FEATURE5_TITLE' | translate }}</span>
                        </a>
                    </h4>
                </div>
                <div class="widget-content">
                    <p class="widget-text">
                        <a class="tooltip-text-content" (click)="onWidgetClick('data_beneficiar_real_contract')">
                            <span>{{ 'DOCUMENTS.FEATURE5_TEXT' | translate }}</span>
                        </a>
                    </p>
                    <div class="features-btn-wrapper">
                        <div class="dropdown">
                            <button class="features-btn"
                                (click)="toggleDropdown($event, 'data_beneficiar_real_contract')">
                                <i class="lni lni-download"></i>
                                Descarcă document
                            </button>
                            <div class="dropdown-menu"
                                [class.show]="activeDropdownId === 'data_beneficiar_real_contract'">
                                <a href="javascript:void(0)" class="dropdown-item pdf"
                                    (click)="redirectToPayment('data_beneficiar_real_contract_pdf')"
                                    *ngIf="getDocumentPriceDetails('data_beneficiar_real_contract_pdf', 'pdf') as data_beneficiar_real_contract_pdf">
                                    <i class="lni lni-pdf"></i>
                                    Format PDF ({{ data_beneficiar_real_contract_pdf?.documentPrice || '0.00' }} {{
                                    data_beneficiar_real_contract_pdf?.documentCurrency || 'RON' }})
                                </a>

                                <a href="javascript:void(0)" class="dropdown-item docx"
                                    (click)="redirectToPayment('data_beneficiar_real_contract_docx')"
                                    *ngIf="getDocumentPriceDetails('data_beneficiar_real_contract_docx', 'docx') as data_beneficiar_real_contract_docx">
                                    <i class="lni lni-file"></i>
                                    Format DOCX ({{ data_beneficiar_real_contract_docx?.documentPrice || '0.00' }} {{
                                    data_beneficiar_real_contract_docx?.documentCurrency || 'RON' }})
                                </a>

                                <a href="javascript:void(0)" class="dropdown-item odt"
                                    (click)="redirectToPayment('data_beneficiar_real_contract_odt')"
                                    *ngIf="getDocumentPriceDetails('data_beneficiar_real_contract_odt', 'odt') as data_beneficiar_real_contract_odt">
                                    <i class="lni lni-text"></i>
                                    Format ODT ({{ data_beneficiar_real_contract_odt?.documentPrice || '0.00' }} {{
                                    data_beneficiar_real_contract_odt?.documentCurrency || 'RON' }})
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="feature-widget">
                <div class="widget-badge free" (click)="onWidgetClick('acord_gdpr')"
                    *ngIf="getDocumentWidgetPrice('acord_gdpr') as acordGdprPrice">
                    {{ acordGdprPrice?.price || '0.00' }} {{ acordGdprPrice?.currency || 'RON' }}
                </div>

                <div class="widget-header">
                    <div class="widget-icon">
                        <i class="lni lni-cog"></i>
                    </div>
                    <h4 class="widget-title">
                        <a (click)="onWidgetClick('acord_gdpr')">
                            <span class="tooltip-text-title">{{ 'DOCUMENTS.FEATURE6_TITLE' | translate }}</span>
                        </a>
                    </h4>
                </div>
                <div class="widget-content">
                    <p class="widget-text">
                        <a class="tooltip-text-content" (click)="onWidgetClick('acord_gdpr')">
                            <span>{{ 'DOCUMENTS.FEATURE6_TEXT' | translate }}</span>
                        </a>
                    </p>
                    <div class="features-btn-wrapper">
                        <div class="dropdown">
                            <button class="features-btn" (click)="toggleDropdown($event, 'acord_gdpr')">
                                <i class="lni lni-download"></i>
                                Descarcă document
                            </button>
                            <div class="dropdown-menu" [class.show]="activeDropdownId === 'acord_gdpr'">
                                <a href="javascript:void(0)" class="dropdown-item pdf"
                                    (click)="redirectToPayment('acord_gdpr_pdf')"
                                    *ngIf="getDocumentPriceDetails('acord_gdpr_pdf', 'pdf') as acord_gdpr_pdf">
                                    <i class="lni lni-pdf"></i>
                                    Format PDF ({{ acord_gdpr_pdf?.documentPrice || '0.00' }} {{
                                    acord_gdpr_pdf?.documentCurrency || 'RON' }})
                                </a>

                                <a href="javascript:void(0)" class="dropdown-item docx"
                                    (click)="redirectToPayment('acord_gdpr_docx')"
                                    *ngIf="getDocumentPriceDetails('acord_gdpr_docx', 'docx') as acord_gdpr_docx">
                                    <i class="lni lni-file"></i>
                                    Format DOCX ({{ acord_gdpr_docx?.documentPrice || '0.00' }} {{
                                    acord_gdpr_docx?.documentCurrency || 'RON' }})
                                </a>

                                <a href="javascript:void(0)" class="dropdown-item odt"
                                    (click)="redirectToPayment('acord_gdpr_odt')"
                                    *ngIf="getDocumentPriceDetails('acord_gdpr_odt', 'odt') as acord_gdpr_odt">
                                    <i class="lni lni-text"></i>
                                    Format ODT ({{ acord_gdpr_odt?.documentPrice || '0.00' }} {{
                                    acord_gdpr_odt?.documentCurrency || 'RON' }})
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>

<section id="contact" class="contact-area grey-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-30">
                    <h3 class="title">{{ 'HOME.SECTION_CONTACTUS_TITLE' | translate }}</h3>
                    <p class="text">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="contact-wrapper">
                    <h4 class="contact-title">
                        <i class="lni lni-envelope"></i>
                        {{ 'HOME.TEXT_MESSAGE' | translate }}
                    </h4>
                    <form #contactForm="ngForm">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'HOME.NAME' | translate }}</label>
                                    <div class="input-items">
                                        <input type="text" name="name" placeholder="{{ 'HOME.NAME' | translate }}"
                                            [(ngModel)]="contactItem.subject" required>
                                        <i class="lni lni-user"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'HOME.EMAIL' | translate }}</label>
                                    <div class="input-items">
                                        <input type="email" name="email" placeholder="{{ 'HOME.EMAIL' | translate }}"
                                            [(ngModel)]="contactItem.email" required>
                                        <i class="lni lni-envelope"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-input">
                                    <label>{{ 'HOME.MESSAGE' | translate }}</label>
                                    <div class="input-items textarea">
                                        <textarea name="message" placeholder="{{ 'HOME.MESSAGE' | translate }}"
                                            [(ngModel)]="contactItem.content" required></textarea>
                                        <i class="lni lni-pencil-alt"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="text-center">

                                    <div class="page-button">
                                        <div class="features-btn-wrapper">
                                            <a (click)="send()" class="features-btn">
                                                <i class="lni lni-arrow-right"></i>
                                                {{'HOME.SEND' |
                                                translate }}
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>






















<!-- 

<section class="features-area white-area">
    <div class="container">

        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-10">
                    <h3 class="title">{{'DOCUMENTS.TITLE' | translate }}</h3>
                    <p class="text">{{'DOCUMENTS.TITLE_DESCRIPTION_LONG' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">

            <div class="col-lg-4 col-md-7 col-sm-9">
                <div class="single-features mt-40">

                    <div class="features-title-icon d-flex justify-content-between">
                        <h4 class="features-title">
                            <a (click)="generateReportRentingContract()" target="_blank">
                                <span class="tooltip-text-title">{{ 'DOCUMENTS.FEATURE1_TITLE' | translate }}</span>
                            </a>
                        </h4>
                        <div class="features-icon">
                            <i class="lni lni-display-alt"></i>
                            <img class="shape" src="assets/images/Shape-1.svg" alt="Shape">
                        </div>
                    </div>

                    <div class="features-content">
                        <p class="text">
                            <a class="tooltip-text-content" (click)="generateReportRentingContract()" target="_blank">
                                <span>{{ 'DOCUMENTS.FEATURE1_TEXT' | translate }}</span>
                            </a>
                        </p>
                        <a class="features-btn" (click)="generateReportRentingContract()" target="_blank">
                            {{ 'DOCUMENTS.DOWNLOAD' | translate }}
                        </a>
                    </div>

                </div>
            </div>

            <div class="col-lg-4 col-md-7 col-sm-9">
                <div class="single-features mt-40">

                    <div class="features-title-icon d-flex justify-content-between">
                        <h4 class="features-title">
                            <a (click)="generateReportInventory()" target="_blank">
                                <span class="tooltip-text-title">{{ 'DOCUMENTS.FEATURE2_TITLE' | translate }}</span>
                            </a>
                        </h4>
                        <div class="features-icon">
                            <i class="lni lni-display-alt"></i>
                            <img class="shape" src="assets/images/Shape-1.svg" alt="Shape">
                        </div>
                    </div>

                    <div class="features-content">
                        <p class="text">
                            <a class="tooltip-text-content" (click)="generateReportInventory()" target="_blank">
                                <span>{{ 'DOCUMENTS.FEATURE2_TEXT' | translate }}</span>
                            </a>
                        </p>
                        <a class="features-btn" (click)="generateReportInventory()" target="_blank">
                            {{ 'DOCUMENTS.DOWNLOAD' | translate }}
                        </a>
                    </div>

                </div>
            </div>

            <div class="col-lg-4 col-md-7 col-sm-9">
                <div class="single-features mt-40">

                    <div class="features-title-icon d-flex justify-content-between">
                        <h4 class="features-title">
                            <a (click)="generateReportSubRentingContract()" target="_blank">
                                <span class="tooltip-text-title">{{ 'DOCUMENTS.FEATURE3_TITLE' | translate }}</span>
                            </a>
                        </h4>
                        <div class="features-icon">
                            <i class="lni lni-display-alt"></i>
                            <img class="shape" src="assets/images/Shape-1.svg" alt="Shape">
                        </div>
                    </div>

                    <div class="features-content">
                        <p class="text">
                            <a class="tooltip-text-content" (click)="generateReportSubRentingContract()"
                                target="_blank">
                                <span>{{ 'DOCUMENTS.FEATURE3_TEXT' | translate }}</span>
                            </a>
                        </p>
                        <a class="features-btn" (click)="generateReportSubRentingContract()" target="_blank">
                            {{ 'DOCUMENTS.DOWNLOAD' | translate }}
                        </a>
                    </div>

                </div>
            </div>
            <div class="col-lg-4 col-md-7 col-sm-9">
                <div class="single-features mt-40">

                    <div class="features-title-icon d-flex justify-content-between">
                        <h4 class="features-title">
                            <a (click)="generateRequestEndContractBeforeEndOfTerm()" target="_blank">
                                <span class="tooltip-text-title">{{ 'DOCUMENTS.FEATURE4_TITLE' | translate }}</span>
                            </a>
                        </h4>
                        <div class="features-icon">
                            <i class="lni lni-display-alt"></i>
                            <img class="shape" src="assets/images/Shape-1.svg" alt="Shape">
                        </div>
                    </div>

                    <div class="features-content">
                        <p class="text">
                            <a class="tooltip-text-content" (click)="generateRequestEndContractBeforeEndOfTerm()"
                                target="_blank">
                                <span>{{ 'DOCUMENTS.FEATURE4_TEXT' | translate }}</span>
                            </a>
                        </p>
                        <a class="features-btn" (click)="generateRequestEndContractBeforeEndOfTerm()" target="_blank">
                            {{ 'DOCUMENTS.DOWNLOAD' | translate }}
                        </a>
                    </div>

                </div>
            </div>

            <div class="col-lg-4 col-md-7 col-sm-9">
                <div class="single-features mt-40">

                    <div class="features-title-icon d-flex justify-content-between">
                        <h4 class="features-title">
                            <a (click)="generateDataBeneficiarRealContract()" target="_blank">
                                <span class="tooltip-text-title">{{ 'DOCUMENTS.FEATURE5_TITLE' | translate }}</span>
                            </a>
                        </h4>
                        <div class="features-icon">
                            <i class="lni lni-display-alt"></i>
                            <img class="shape" src="assets/images/Shape-1.svg" alt="Shape">
                        </div>
                    </div>

                    <div class="features-content">
                        <p class="text">
                            <a class="tooltip-text-content" (click)="generateDataBeneficiarRealContract()"
                                target="_blank">
                                <span>{{ 'DOCUMENTS.FEATURE5_TEXT' | translate }}</span>
                            </a>
                        </p>
                        <a class="features-btn" (click)="generateDataBeneficiarRealContract()" target="_blank">
                            {{ 'DOCUMENTS.DOWNLOAD' | translate }}
                        </a>
                    </div>

                </div>
            </div>

            <div class="col-lg-4 col-md-7 col-sm-9">
                <div class="single-features mt-40">

                    <div class="features-title-icon d-flex justify-content-between">
                        <h4 class="features-title">
                            <a (click)="generateAcordGDPR()" target="_blank">
                                <span class="tooltip-text-title">{{ 'DOCUMENTS.FEATURE6_TITLE' | translate }}</span>
                            </a>
                        </h4>
                        <div class="features-icon">
                            <i class="lni lni-display-alt"></i>
                            <img class="shape" src="assets/images/Shape-1.svg" alt="Shape">
                        </div>
                    </div>

                    <div class="features-content">
                        <p class="text">
                            <a class="tooltip-text-content" (click)="generateAcordGDPR()" target="_blank">
                                <span>{{ 'DOCUMENTS.FEATURE6_TEXT' | translate }}</span>
                            </a>
                        </p>
                        <a class="features-btn" (click)="generateAcordGDPR()" target="_blank">
                            {{ 'DOCUMENTS.DOWNLOAD' | translate }}
                        </a>
                    </div>

                </div>
            </div>

        </div>
    </div>
</section> -->